/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { createAgent } from '@vlinder-web/plugin-agent-service-react';
import {
  AnalyticsPlugin,
  IAnalyticsPluginMethods,
  ErrorAnalyticsPlugin,
  IErrorAnalyticsPluginMethods,
  HeaderAnalyticsPlugin,
  IHeaderAnalyticsPluginMethods,
  SettingsAnalyticsPlugin,
  ISettingsAnalyticsPluginMethods,
  StaticPageAnalyticsPlugin,
  IStaticPageAnalyticsPluginMethods,
  LoadingAnalyticsPlugin,
  ILoadingAnalyticsPluginMethods,
} from './plugins';

export type TAgent = IAnalyticsPluginMethods &
  IErrorAnalyticsPluginMethods &
  IHeaderAnalyticsPluginMethods &
  ISettingsAnalyticsPluginMethods &
  IStaticPageAnalyticsPluginMethods &
  ILoadingAnalyticsPluginMethods;

const getPlugins = () => {
  return [
    new StaticPageAnalyticsPlugin(),
    new ErrorAnalyticsPlugin(),
    new LoadingAnalyticsPlugin(),
    //Business logic plugins !
    new AnalyticsPlugin(),
    new HeaderAnalyticsPlugin(),
    new SettingsAnalyticsPlugin(),
  ];
};

export const getAgent = () => {
  return createAgent<TAgent>({
    plugins: getPlugins(),
  });
};
